<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table">
          <tr class="th-plugin-line--subheader">
            <td>
              <span>N°</span>
            </td>
            <td style="width: 45%">
              <span>{{ 'plugins.cylindrical-parallelism.description' | translate }}</span>
            </td>
            <td class="th-plugin-line--value" style="width: 15%">
              <span>{{ 'plugins.cylindrical-parallelism.left' | translate }}</span>
            </td>
            <td class="th-plugin-line--value" style="width: 15%">
              <span>{{ 'plugins.cylindrical-parallelism.right' | translate }}</span>
            </td>
            <td class="th-plugin-line--value" colspan="2">
              <span>{{ 'plugins.cylindrical-parallelism.tolerances' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input" *ngFor="let item of cylindricalParallelisms; let i = index">
            <td>
              <span>{{ item.Id }}.</span>
            </td>
            <td>
              <div class="ir-form-group margin">
                <input name="item.Description-{{ i }}" class="ir-form-set" type="text" [(ngModel)]="item.Description" />
              </div>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input name="item.Left-{{ i }}" class="ir-form-set" type="number" step="any" [(ngModel)]="item.Left" />
              </div>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  name="item.Right-{{ i }}"
                  class="ir-form-set"
                  type="number"
                  step="any"
                  [(ngModel)]="item.Right"
                />
              </div>
            </td>
            <td class="th-plugin-line--value important">
              <span>{{ item.Right - item.Left | number : '1.2-3' }}mm</span>
            </td>
            <td class="th-plugin-line--remove">
              <i class="material-icons" (click)="remove(i)">remove_circle</i>
            </td>
          </tr>
          <tr class="th-plugin-line--add">
            <td colspan="8">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            (click)="save()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
